/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */
/** @jsx jsx */

import { jsx, css } from '@emotion/react'

import { EuiEmptyPrompt } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'
import { isPrepaidAccount } from '@modules/billing-lib/billingDetails/utils'
import useBillingDetails from '@modules/billing-lib/billingDetails/useBillingDetails'

import BillingHistoryPanel from '../BillingHistoryPanel'

import type { FunctionComponent } from 'react'

const BillingHistoryEmptyPrompt: FunctionComponent = () => {
  const billingDetails = useBillingDetails()
  const statements = (
    <FormattedMessage id='billing-history.statements' defaultMessage='statements' />
  )
  const invoices = <FormattedMessage id='billing-history.invoices' defaultMessage='invoices' />
  const documents =
    billingDetails.data && isPrepaidAccount(billingDetails.data) ? statements : invoices

  return (
    <BillingHistoryPanel data-test-id='billing-history-empty-prompt'>
      <EuiEmptyPrompt
        css={css({ maxWidth: `50em` })}
        title={
          <h2>
            <FormattedMessage
              id='billing-history.empty-title'
              defaultMessage='You have no {documents}'
              values={{ documents }}
            />
          </h2>
        }
        body={
          <FormattedMessage
            id='billing-history.empty-content'
            defaultMessage='New {documents} will show here the first day of the month.'
            values={{ documents }}
          />
        }
      />
    </BillingHistoryPanel>
  )
}

export default BillingHistoryEmptyPrompt
